import Vue from 'vue'

// debug component
import Highlight from 'components/highlight'

import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VMenu,
  VTextField,
  VCard,
  VForm,
  VAvatar,
  VImg,
  VSelect,
  VDatePicker,
  VCheckbox,
  VDivider,
  VPagination,
  VDialog,
  VProgressCircular,
  VTooltip,
  VSwitch,
  VAutocomplete,
  VChip,
  VDataTable,
  VSnackbar,
  VRadioGroup,
  VTabs,
  VTimePicker,
  VExpansionPanel,
  VProgressLinear,
  VTextarea,
  VCombobox,
  VAlert
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

// locales
import pt from 'vuetify/es5/locale/pt'
import en from 'vuetify/es5/locale/en'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VMenu,
    VTextField,
    VCard,
    VForm,
    VAvatar,
    VImg,
    VSelect,
    VDatePicker,
    VCheckbox,
    VDivider,
    VPagination,
    VDialog,
    VProgressCircular,
    VTooltip,
    VSwitch,
    VAutocomplete,
    VChip,
    VDataTable,
    VSnackbar,
    VRadioGroup,
    VTabs,
    VTimePicker,
    VExpansionPanel,
    VProgressLinear,
    VTextarea,
    VCombobox,
    VAlert
  },
  theme: {
    primary: '#FFDD00',
    secondary: '#FF5A00',
    accent: '#FF8200',
    error: '#E20D0D',
    info: '#2196F3',
    success: '#2DCC70',
    warning: '#EEC216'
  },
  lang: {
    locales: { pt, en },
    current: 'pt-BR'
  }
})

Vue.component('Debug', Highlight)
